export default "__VITE_ASSET__5pWwMt7D__"